import VideoPlayerVote from './VideoPlayerVote'

export default VideoPlayerVote
// eslint-disable-next-line import/export
export * from './VideoPlayerVote'
